import React from "react";
import styled from "styled-components";

import { BlocksContent, Image, Link } from "@global";
import { SanityLeftRightBlock } from "@graphql-types";
import { Container } from "@util/standard";
import { mediaQuery } from "@util/constants";

interface Props {
  data: SanityLeftRightBlock;
}

const TextWrapper = styled.div`
  width: 62.5%;
  margin: auto;

  ${mediaQuery.largeDown} {
    width: 85%;
  }
`;

const ImageWrapper = styled(Container)`
  ${mediaQuery.largeDown} {
    height: 500px;
  }

  ${mediaQuery.smallDown} {
    height: 450px;
  }
`;

function LeftRightBlock({ data }: Props) {
  if (data == null) return null;

  const { blockLink, blockText, image, reverse } = data;

  return (
    <Container flexDirection={reverse ? "row-reverse" : "row"} tabletFlexDirection="column">
      {image && (
        <ImageWrapper width="50%" tabletWidth="100%">
          <Image data={image} objectFit="cover" width="100%" />
        </ImageWrapper>
      )}
      {blockText && (
        <Container width="50%" tabletWidth="100%">
          <TextWrapper>
            <BlocksContent data={blockText} />
            {blockLink && (
              <Container margin="40px 0 100px 0">
                <Link {...blockLink} design="outlineDark" useIcon="iconRightArrow" />
              </Container>
            )}
          </TextWrapper>
        </Container>
      )}
    </Container>
  );
}

export default LeftRightBlock;
